class SlideActionsData {

    constructor() {

        this._FRIEND_FOLLOW_ACTION = "follow";
        this._FRIEND_EMAIL_ACTION = "email";
        this._FRIEND_CALL_ACTION = "call";
        this._FRIEND_CHAT_ACTION = "chat";
        this._FRIEND_CHALLENGE_ACTION = "challenge";

        this._DOCUMENT_LIKE_ACTION = "like";
        this._DOCUMENT_FAVOURITE_ACTION = "favourite";
        this._DOCUMENT_COMMENT_ACTION = "comment";
        this._DOCUMENT_RATE_ACTION = "rate";
        this._DOCUMENT_SHARE_ACTION = "share";
        this._DOCUMENT_SHARE_CHAT_ACTION = "shareChat";

    }

    getFriendsActions() {

        return {
            FOLLOW_ACTION: this._FRIEND_FOLLOW_ACTION,
            EMAIL_ACTION: this._FRIEND_EMAIL_ACTION,
            CALL_ACTION: this._FRIEND_CALL_ACTION,
            CHAT_ACTION: this._FRIEND_CHAT_ACTION,
            CHALLENGE_ACTION: this._FRIEND_CHALLENGE_ACTION
        }

    }

    getDocumentActions() {

        return {
            LIKE_ACTION: this._DOCUMENT_LIKE_ACTION,
            FAVOURITE_ACTION: this._DOCUMENT_FAVOURITE_ACTION,
            COMMENT_ACTION: this._DOCUMENT_COMMENT_ACTION,
            RATE_ACTION: this._DOCUMENT_RATE_ACTION,
            SHARE_ACTION: this._DOCUMENT_SHARE_ACTION,
            SHARE_CHAT_ACTION: this._DOCUMENT_SHARE_CHAT_ACTION,
        }

    }

}